/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Currency } from './currency';
import { SettlementReason } from './settlementReason';
import { Status } from './status';
import { TransactionType } from './transactionType';

export interface SettlementTransactionLogModel { 
    merchantId?: string;
    clientResourceId?: string;
    transactionNote?: string;
    clientAuthId?: string;
    resourceId?: string;
    clientName?: string;
    resourceName?: string;
    currency?: Currency;
    amount?: number;
    reason?: SettlementReason;
    isSuccessful?: boolean;
    status?: Status;
    walletId?: string;
    walletName?: string;
    transactionType?: TransactionType;
    transactionStamp?: Date;
}